var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"nav header",staticStyle:{"padding-top":"150px"}},[_c('router-link',{staticStyle:{"color":"#989faa","padding-right":"0"},attrs:{"to":"/","exact":""}},[_c('i',{staticClass:"fab fa-fort-awesome"})]),_vm._v(" "),_vm._l((_vm.list),function(ref){
var id = ref.id;
var name = ref.name;
return _c('span',{key:id,staticClass:"nav-span"},[_c('router-link',{staticStyle:{"color":"#989faa"},attrs:{"to":("/product/" + id)}},[_vm._v(_vm._s(name))])],1)})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e3c41266","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Nav.vue
// module id = null
// module chunks = 